<template>
  <section class="section5 d-flex align-items-center" ref="sectionRef">
    <div class="container-fluid px-5">
      <!-- Titre -->
      <h2 class="text-center fw-bold mb-3" :class="{ 'animated slide-left delay-0': isVisible }">
        <span class="badge bg-primary fs-2">
          Solutions Téléphoniques
        </span>
      </h2>

      <!-- Badge -->
      <div class="text-center mb-4" :class="{ 'animated slide-left delay-1': isVisible }">
        <span class="badge bg-primary fs-2">
          Transfert D’unités/Valeurs Par Téléphone
        </span>
      </div>

      <!-- Image + Cartes -->
      <div class="row align-items-center">
        <!-- Image à gauche -->
        <div class="col-lg-6 mb-4 mb-lg-0 text-center">
          <img
            src="@/assets/section5/phone.png"
            alt="Téléphonie"
            class="img-fluid rounded"
            :class="{ 'animated slide-left delay-2': isVisible }"
          />
        </div>

        <!-- Cartes à droite -->
        <div class="col-lg-6">
          <div class="row g-3">
            <!-- Card 1 -->
            <div class="col-12">
              <div
                class="card shadow border-0 border-bottom border-primary border-4 h-100 animated slide-right delay-0"
                v-if="isVisible"
              >
                <div class="card-body">
                  <h3 class="card-title fw-bold">Présentation générale</h3>
                  <p class="card-text">
                    Il s'agit d'un service de rechargement direct pris en charge par tous les réseaux ;<br />
                    Il s'agit d'un porte-monnaie virtuel indépendant de la carte SIM.
                    L'utilisateur utilise son téléphone pour s'abonner au service.
                  </p>
                </div>
              </div>
            </div>

            <!-- Card 2 -->
            <div class="col-12">
              <div
                class="card shadow border-0 border-bottom border-primary border-4 h-100 animated slide-right delay-1"
                v-if="isVisible"
              >
                <div class="card-body">
                  <h3 class="card-title fw-bold">Usage</h3>
                  <p class="card-text">
                    Les utilisateurs composent une chaîne pour effectuer des transactions :
                  </p>
                  <ul>
                    <li>Recharge pour un client ;</li>
                    <li>Vérifier le solde du compte ;</li>
                    <li>Créer un nouveau détaillant ;</li>
                    <li>Transférer de la valeur électronique.</li>
                  </ul>
                </div>
              </div>
            </div>

            <!-- Card 3 -->
            <div class="col-12">
              <div
                class="card shadow border-0 border-bottom border-primary border-4 h-100 animated slide-right delay-2"
                v-if="isVisible"
              >
                <div class="card-body">
                  <h3 class="card-title fw-bold">Marché cible</h3>
                  <p class="card-text">
                    Revendeurs, grossistes et détaillants.
                  </p>
                </div>
              </div>
            </div>
          </div> <!-- row -->
        </div> <!-- col -->
      </div> <!-- row -->
    </div> <!-- container-fluid -->
  </section>
</template>

<script>
import { useInView } from '@/composables/useInView.js'

export default {
  name: "Section5View",
  setup() {
    const { isVisible, target: sectionRef } = useInView({
      threshold: 0.2,
      rootMargin: '0px 0px -100px 0px'
    })
    return { isVisible, sectionRef }
  }
}
</script>

<style scoped>
.section5 {
  min-height: 100vh;
  padding: 4rem 0;
  font-family: 'Public Sans', sans-serif;
  background-color: #f7f9fb;
}

.section5 img {
  max-width: 100%;
  width: 90%;
  height: auto;
  object-fit: cover;
}

/* === ANIMATIONS === */
.animated {
  opacity: 0;
  animation-fill-mode: forwards;
}

.slide-left {
  transform: translateX(-120px);
  animation: slideInLeft 1.1s cubic-bezier(0.65, 0, 0.35, 1.5) forwards;
}

.slide-right {
  transform: translateX(120px);
  animation: slideInRight 1.1s cubic-bezier(0.65, 0, 0.35, 1.5) forwards;
}

@keyframes slideInLeft {
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes slideInRight {
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

/* Délais d'animation */
.delay-0 { animation-delay: 0.4s; }
.delay-1 { animation-delay: 0.6s; }
.delay-2 { animation-delay: 0.9s; }

/* Cartes */
.card {
  transition: all 0.3s ease;
    background-color: #f1f4f9;

}

.card:hover {
  transform: translateY(-5px) scale(1.02);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.15);
}

/* Responsive */
@media (max-width: 991px) {
  .section5 {
    padding: 2rem 0;
  }

  .section5 img {
    margin-bottom: 2rem;
  }
}
</style>
